$(function(){
    window.Branch = window.Branch || {};
    window.Branch.comparisonChart = window.Branch.comparisonChart || {};
    window.Branch.comparisonChart.tableVariables = {};

    var windowWidth;

    const tableBorder = function(sizeTable) {
        let labelIndex = -1;
        for (const [key, value] of Object.entries(sizeTable)) {
            labelIndex = labelIndex + 1;
            let finalLabelIndex = Object.keys(sizeTable).length - 1;
            let tableLabel = document.querySelector(`.table-labels li[data-label-for="${key}"]`);
            let subtractionAmount = 10; 

            if(labelIndex == finalLabelIndex ){
                subtractionAmount = subtractionAmount + 2;
            }
            if(tableLabel){
                tableLabel.style.marginBottom = `${value - subtractionAmount}px`;
            }
          }
      }

      const liLoopSizing = function(sizeTable, liClasses, regularLabelTextHeight, allListItems){
        liClasses.forEach((liClass) => {

          let allLiInstances = document.querySelectorAll(`.table-products__container li.${liClass}`);
          let maxHeight = 0;
          allLiInstances.forEach((liInstance) => {
              liInstance.style.removeProperty("height")
          });
          allLiInstances.forEach((liInstance) => {

              let liHeight = liInstance.offsetHeight;

              if(liHeight > maxHeight){
                  maxHeight = liHeight;
              }
          });
          let labelIndex = parseInt(allLiInstances[0].getAttribute('data-index'));
          let additionalHeight = 0;
          if(labelIndex){
              let previousLi = document.querySelector(`.table-labels li[data-index="${labelIndex + 1}"]`);
              if(previousLi){
                  additionalHeight = previousLi.clientHeight - regularLabelTextHeight;
              }   
          }

          sizeTable[`${liClass}`] = maxHeight;
          allLiInstances.forEach((liInstance) => {
              liInstance.style.height = `${maxHeight + additionalHeight}px`;
          });
      });
      tableBorder(sizeTable);

      let container = allListItems[0].closest('#section-outer');

      if(container && container.getAttribute('data-initialized') == "false"){
          container.setAttribute('data-initialized', true)
      }
      }
   
      window.Branch.comparisonChart.tableCellSizing = function(type){
        let sizeTable = {};
        let liClasses = [];
        let regularLabelTextHeight = 24;
        let allListItems = document.querySelectorAll(`.table-products__container #product-0 li`);

        allListItems.forEach((listItem) => {
            if(listItem.classList.length > 0){
                if(listItem.classList[0] != "table-products__hidden"){
                    liClasses.push(listItem.classList[0]);
                }
            }
        });

        if(type == "load"){
          let firstImage = allListItems[0];
          function checkHeight() {
            if (firstImage.offsetHeight > 0) {
              liLoopSizing(sizeTable, liClasses, regularLabelTextHeight, allListItems);
            } else {
                requestAnimationFrame(checkHeight);
            }
          }
          checkHeight();
        } else {
          liLoopSizing(sizeTable, liClasses, regularLabelTextHeight, allListItems)
        }
      }

    const handleResize = function(){
        if ($(window).width() != windowWidth) {
            if($('.c-iwt-section.section-outer').attr('data-open') == "false"){
                $('.c-iwt-section.section-outer').attr('data-open', true);
                $('.see-more.comparison-chart__modal-open').removeClass('active');
                $(".see-more span").text("See less");
                $(".see-more").addClass('active');
                $('.table-products__hidden').slideToggle(200);
                $('.see-more i').removeClass('fa-angle-down').addClass('fa-angle-up');
            } 
            window.Branch.comparisonChart.tableCellSizing();
            windowWidth = $(window).width();
        }
        window.Branch.comparisonChart.tableVariables['elOffset'] = columnWidth();
        window.Branch.comparisonChart.tableVariables['parWidth'] = parentWidth();
        window.Branch.comparisonChart.tableVariables['leftEdge'] = leftInner();
        window.Branch.comparisonChart.tableVariables['outerRight'] = rightOuter();
    }

    function throttle(func, delay) {
      let timeoutId;
      let lastArgs;
      let lastCall = 0;
    
      return function(...args) {
        const now = new Date().getTime();
        const timeSinceLastCall = now - lastCall;
        
        lastArgs = args;
    
        if (timeSinceLastCall >= delay) {
          if (timeoutId) {
            clearTimeout(timeoutId);
            timeoutId = null;
          }
          func.apply(this, lastArgs);
          lastCall = now;
        } else if (!timeoutId) {
          timeoutId = setTimeout(() => {
            func.apply(this, lastArgs);
            lastCall = new Date().getTime();
            timeoutId = null;
          }, delay - timeSinceLastCall);
        }
      };
    }

    const throttledResizeHandler = throttle(handleResize, 100);

    const initTableStyling = function(type){
        window.Branch.comparisonChart.tableCellSizing(type);

        $(`.see-more span`).text("See more");
        $(`.see-more`).removeClass('active');
        $(`.table-products__hidden`).slideToggle(200);
        $(`.see-more i`).toggleClass('fa-angle-down fa-angle-up');
        windowWidth = $(window).width();

        window.addEventListener('resize', throttledResizeHandler)
    }

    const columnWidth = () =>{
        return $('.table-products__container ul').outerWidth();
      }

    const parentWidth = () => {
    return $('.table-products__container').outerWidth()
    }

    const leftInner = () => {
    if($('.table-products__container > ul').first().offset()){
        return $('.table-products__container > ul').first().offset().left
    }
    }

    const rightOuter = () => {
    if($('.table-products__outer').offset()){
        return $(window).width() - ($('.table-products__outer').offset().left + $('.table-products__outer').outerWidth())
    }
    }

    const closeModal = function(modalClass) {  
        const scrollY = $(document.body).css('top');
        $(document.body).css('position','').css('top','').css('width','')
        $(".section-outer").html($('.scroll-outer'))
        $(modalClass).hide();
        window.scrollTo({top: parseInt(scrollY || '0') * -1, left: 0, behavior: "instant",});
        window.Branch.comparisonChart.tableVariables['closedOffset'] = Math.round(window.Branch.comparisonChart.tableVariables['elOffset'])
        window.Branch.comparisonChart.tableVariables['elOffset'] = columnWidth()
        window.Branch.comparisonChart.tableVariables['ratio'] = (window.Branch.comparisonChart.tableVariables['elOffset']/window.Branch.comparisonChart.tableVariables['closedOffset']).toFixed(2)
        $(".table-products__outer").scrollLeft(window.Branch.comparisonChart.tableVariables['lastScrollLeft']*window.Branch.comparisonChart.tableVariables['ratio'])
      }

    const initSeeMore = function(){
        $(`.see-more`).click(function(e){
            if($(this).hasClass("comparison-chart__modal-open")){
              if($(window).width() <= 600 && $(this).closest('#section-outer').attr('data-quick-view') == 'false'){
                showDialog(`.comparison-chart__modal-outer`);
                $(`.table-products__modal-overlay`).css('display', 'block')
                parWidth = parentWidth();
              } 
              $(this).toggleClass('active')
              let text = $(`.see-more`).hasClass("active") ? "See less" : "See more";
              $(`.see-more`).hasClass("active") ? $(`.c-iwt-section.section-outer`).attr('data-open', true) : $(`.c-iwt-section.section-outer`).attr('data-open', false);
              ;
              $(`.see-more span`).text(text)
              $(`.table-products__hidden`).slideToggle(200)
              $(`.see-more i`).toggleClass('fa-angle-up fa-angle-down');
              if($(window).width() <= 600 && $(this).closest('#section-outer').attr('data-quick-view') == 'false'){
                window.Branch.comparisonChart.tableCellSizing();
              } 
            } else if ($(this).hasClass("pdp-qa-modal__open")){
              e.preventDefault;
              showDialog(`.pdp-qa-modal__outer`);
            }
          })
    }

    const returnTableVariables = function(){
        let tableVariables = {};
        tableVariables['elOffset'] = columnWidth();
        tableVariables['closedOffset'] = 0;
        tableVariables['ratio'] = 0;
        tableVariables['prodCol'] = $(`.table-products__container ul[id^="product"]`).length;
        tableVariables['parWidth'] = parentWidth();
        tableVariables['lastScrollLeft'] = 0;
        tableVariables['scrollMax'] = Math.floor((tableVariables['elOffset'] * tableVariables['prodCol']) - tableVariables['parWidth']);
        tableVariables['rightEdge'] = 0;
        tableVariables['leftEdge'] = 0;
        tableVariables['outerRight'] = 0;
        tableVariables['documentScrollLeft'] = 0;

        if($('.table-products__container').length){
            tableVariables['rightEdge'] = $(window).width() - ($(`.table-products__container`).offset().left + (tableVariables['elOffset'] * tableVariables['prodCol']));
            tableVariables['leftEdge'] = leftInner();
            tableVariables['outerRight'] = rightOuter();
          }

        return tableVariables;
    }

    const initOverlayEventListener = function(){
        $(`.modal__btn--close, .table-products__modal-overlay`).click(function(){
            if ($(this).hasClass("comparison-chart__modal-btn--close") || $(this).hasClass("table-products__modal-overlay")){
              $(`.table-products__hidden`).slideToggle(200)
              $(`.see-more`).removeClass('active') 
              $(`.see-more span`).text("See more")
              $(`.see-more i`).toggleClass('fa-angle-up fa-angle-down')
              closeModal(`.comparison-chart__modal-outer`);
              $(`.table-products__modal-overlay`).css('display', 'none');
    
            } else if ($(this).hasClass("qa-modal__btn--close")){
              closeModal(`.pdp-qa-modal__outer`)
            }
          })
    }

    const hideShowDirectionContainer = function(){
        if ((window.Branch.comparisonChart.tableVariables['elOffset'] * window.Branch.comparisonChart.tableVariables['prodCol']) < window.Branch.comparisonChart.tableVariables['parentWidth']){
            $(`.direction-container`).hide();
          }
    }

    const showDialog = (modalClass) => {
        const scrollY = document.documentElement.style.getPropertyValue('--scroll-y');
        $("#modal__inner").append($('.scroll-outer'));
        $(modalClass.toString()).show();
        $(document.body).css('position','fixed').css('top', -1*scrollY).css('width','100%')
        window.Branch.comparisonChart.tableVariables['closedOffset'] = Math.round(window.Branch.comparisonChart.tableVariables['elOffset'])
        window.Branch.comparisonChart.tableVariables['elOffset'] = columnWidth()
        window.Branch.comparisonChart.tableVariables['ratio'] = (window.Branch.comparisonChart.tableVariables['elOffset']/window.Branch.comparisonChart.tableVariables['closedOffset']).toFixed(2)
        $(".table-products__outer").scrollLeft(window.Branch.comparisonChart.tableVariables['lastScrollLeft'] * window.Branch.comparisonChart.tableVariables['ratio'])
      };

    const initModal = function(){
        initOverlayEventListener();

        /// CLOSE MODAL WHEN CLICKING OUTER
	    $(`.pdp-qa-modal__outer`).click(function(){
            if($(`.pdp-qa-modal__outer`).is(':visible')) {
                 window.Branch.comparisonChart.closeModal(` .pdp-qa-modal__outer`)
            }
        });

        /// CLOSE MODAL WHEN PRESSING ESC

        $(document).keydown(function(event) { 
            if (event.keyCode == 27) { 
                window.Branch.comparisonChart.closeModal(".pdp-qa-modal__outer")
            }
        });
    }

    const btnOpacity = (blur) => {
        if (blur === "left"){
          $('.btn--prev').css('opacity', '.3').css('pointer-events', 'none');
          $('.btn--next').css('opacity', '1').css('pointer-events', 'auto');     
        } else if (blur === "right") {
          $('.btn--prev').css('opacity', '1').css('pointer-events', 'auto');     
          $('.btn--next').css('opacity', '.3').css('pointer-events', 'none');      
        } else {
          $('.btn--prev').css('opacity', '1').css('pointer-events', 'auto');     
          $('.btn--next').css('opacity', '1').css('pointer-events', 'auto');           
        }
      }

    const initVerticalScroll = function(){
        $(`.table-products__outer`).scroll($.throttle(150, function() {
            window.Branch.comparisonChart.tableVariables['documentScrollLeft'] = $(`.table-products__outer`).scrollLeft();
            let blur = "";
    
            Math.floor((window.Branch.comparisonChart.tableVariables['elOffset'] * window.Branch.comparisonChart.tableVariables['prodCol']) - window.Branch.comparisonChart.tableVariables['parWidth']);
    
            if (window.Branch.comparisonChart.tableVariables['lastScrollLeft'] != window.Branch.comparisonChart.tableVariables['documentScrollLeft']) {
                window.Branch.comparisonChart.tableVariables['lastScrollLeft'] = window.Branch.comparisonChart.tableVariables['documentScrollLeft'];
            }

            if (window.Branch.comparisonChart.tableVariables['lastScrollLeft'] == 0) {
              blur = "left"
            } else if ((window.Branch.comparisonChart.tableVariables['lastScrollLeft'] + 1) < window.Branch.comparisonChart.tableVariables['scrollMax']) {
              blur = "none"
            } else {
              blur = "right"
            }
            btnOpacity(blur)
          }));
    }

    const handleButtonClick = function(event) {
      let button = event.target.closest('.odirection-container__btn') ? event.target.closest('.odirection-container__btn') : event.target 
      let blur = "";
    
      window.Branch.comparisonChart.tableVariables['leftEdge'] = button.getAttribute("id") === "right"
        ? window.Branch.comparisonChart.tableVariables['leftEdge'] - window.Branch.comparisonChart.tableVariables['elOffset']
        : window.Branch.comparisonChart.tableVariables['leftEdge'] + window.Branch.comparisonChart.tableVariables['elOffset'];
    
      // Use vanilla JS for animation and scrolling
      const outerElement = document.querySelector('.table-products__outer');
      const scrollAmount = button.getAttribute("id") === "right"
        ? outerElement.scrollLeft + window.Branch.comparisonChart.tableVariables['elOffset']
        : outerElement.scrollLeft - window.Branch.comparisonChart.tableVariables['elOffset'];
    
      outerElement.scrollTo({
        left: scrollAmount,
        behavior: 'smooth'
      });
    
      if (window.Branch.comparisonChart.tableVariables['leftEdge'] === window.Branch.comparisonChart.tableVariables['outerRight']) {
        blur = "left";
      } else if (window.Branch.comparisonChart.tableVariables['rightEdge'] >= window.Branch.comparisonChart.tableVariables['outerRight']) {
        blur = "right";
      } else {
        blur = "none";
      }
      btnOpacity(blur);
    }

    const initLeftRightButtons = function(){
      const buttons = document.querySelectorAll('.btn--next, .btn--prev');
      buttons.forEach(button => {
        button.addEventListener('click', handleButtonClick);
      });
    }     

    const initTableFunctionality = function(){
        window.Branch.comparisonChart.tableVariables = returnTableVariables();
        hideShowDirectionContainer();
        initSeeMore();
        initModal();
        initVerticalScroll();
        initLeftRightButtons();
        
        window.addEventListener('scroll', () => {
            document.documentElement.style.setProperty('--scroll-y', `${window.scrollY}`);
        });
    }

    const removeEventListeners = function(events) {
      Object.keys(events).forEach(selector => {
        const { eventName, callback } = events[selector];
    
        if (selector === 'window') {
          window.removeEventListener(eventName, callback);
        } else {
          const elements = document.querySelectorAll(selector);
    
          elements.forEach(element => {
            element.removeEventListener(eventName, callback);
          });
        }
      });
    }

    window.Branch = window.Branch || {};
    window.Branch.collection = window.Branch.collection || {};

    window.Branch.collection.removeEventListeners = function(){
      const eventHandlers = {
        'window': {
          eventName: 'resize',
          callback: throttledResizeHandler
        },
        '.btn--next': {
          eventName: 'click',
          callback: handleButtonClick
        },
        '.btn--prev': {
          eventName: 'click',
          callback: handleButtonClick
        }
      };
      
      removeEventListeners(eventHandlers);
    }

    window.Branch.collection.initCollectionComparisonChart = function(sectionId){
        const body = document.querySelector('body');
            if(body.classList.contains('templateCollection') && body.querySelectorAll('.comparison-chart-section').length > 0 && body.querySelectorAll('.comparison-chart-section')[0].innerHTML){
                initTableFunctionality();
                initTableStyling('normal');  
            } else if(body.classList.contains('templateProduct') && body.querySelectorAll('.quick-view .comparison-chart-section').length > 0 && body.querySelectorAll('.quick-view .comparison-chart-section')[0].innerHTML){
                initTableFunctionality();
                initTableStyling('load');
            } else if(body.classList.contains('templateProduct') && body.querySelectorAll('.comparison-chart-section').length > 0 && body.querySelectorAll('.comparison-chart-section')[0].innerHTML){
                initTableFunctionality();
                initTableStyling('normal');
            } else if(body.classList.contains('template-page-bundles') && body.querySelectorAll('.comparison-chart-section').length > 0 && body.querySelectorAll('.comparison-chart-section')[0].innerHTML){
                initTableFunctionality();
                initTableStyling('load');
            }
    }
});
